import { trigger, state, style, animate, transition } from '@angular/animations';

export const slideInOutAnimation = trigger('slideInOut', [
  state('void', style({
    transform: 'translateX(100%)',
    opacity: 0
  })),
  state('*', style({
    transform: 'translateX(0)',
    opacity: 1
  })),
  transition(':enter', [
    animate('300ms ease-in-out')
  ]),
  transition(':leave', [
    animate('300ms ease-in-out', style({
      transform: 'translateX(100%)',
      opacity: 0
    }))
  ])
]);
